import { GenresModel } from '@modules/entertainment/models/entertainment.models';
import axiosInstance from '../axios-instance';

export const getGenres = async (type?: any): Promise<GenresModel[]> => {
  const response = await axiosInstance.get(`/media/genres/type/${type}`);
  return response.data;
};

export const createGenre = async (body: any): Promise<GenresModel> => {
  return await axiosInstance.post(`/media/genres`, body);
};

export const editGenre = async (body: any, id: any): Promise<any> => {
  return await axiosInstance.put(`/media/genres/${id}`, body);
};

export const deleteGenre = async (id: any): Promise<any> => {
  return await axiosInstance.delete(`/media/genres/${id}`);
};
